import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '@visurel/iconify-angular';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DisplayBulletinsComponent } from './display-bulletins.component';
import { BulletinModule } from '../bulletin/bulletin.module';

@NgModule({
    declarations: [
        DisplayBulletinsComponent
    ],
    imports: [
        CommonModule,
        MatIconModule,
        IconModule,
        MatButtonModule,
        BulletinModule

    ],
    exports: [
        DisplayBulletinsComponent
    ]
})
export class DisplayBulletinsModule
{
}